import * as actionTypes from "./actionTypes";
import { documentTypeService } from "../../service";
import { authorizationHelper } from "../../common/helpers/index";

export function getDocumentTypes() {
    return async (dispatch) => {
        try {
            dispatch({ type: actionTypes.FETCH_DOCUMENT_TYPE });

            const response = await documentTypeService.getAll();
            const data = response.data;

            if (data.message) {
                dispatch({
                    type: actionTypes.FETCH_DOCUMENT_TYPE_FAILURE,
                    payload: { error: data.message }
                });
                return;
            }

            dispatch({
                type: actionTypes.FETCH_DOCUMENT_TYPE_SUCCESS,
                payload: { documentTypes: data.data, total: 0 }
            });
        } catch (error) {
            if (authorizationHelper.isUnauthorizedCall(dispatch, error.response)) return;
        }
    };
}



// WEBPACK FOOTER //
// ./src/store/document-type/actions.js